module.exports = __webpack_public_path__ + "img/logo-quinta.ad68b137.svg";